namespace $ {

	export class $shm_hitalama_domain_config extends $mol_object {

		/** Resolve obsolete defaults without rewriting an explicit custom domain.
		 * Keeping the stored value intact also makes a deployment rollback safe.
		 */
		static resolve( stored: string | null | undefined, current: string, previous: readonly string[] ) {
			return !stored || previous.includes( stored ) ? current : stored
		}

	}

}
